/**
 * «Nueva categoría» / «Nuevo grupo» (HojaNuevaCategoria): por qué no se
 * puede crear todavía. Sin grupo propuesto por defecto (decisión del
 * 6-oct-2026): la categoría pide elegir uno.
 */
export type MotivoNuevaCategoria = 'nombre' | 'grupo' | null;

export function motivoNuevaCategoria({
  modo,
  nombre,
  grupoId,
}: {
  modo: 'categoria' | 'grupo';
  /** El nombre sin el emoji. */
  nombre: string;
  grupoId: string | null;
}): MotivoNuevaCategoria {
  if (modo === 'categoria' && !grupoId) {
    return 'grupo';
  }
  if (nombre.trim().length === 0) {
    return 'nombre';
  }
  return null;
}
